// Shared constants for the pre-season feature, used both by the coach-facing
// design/progress pages (page-team-pre-season) and the player-facing
// dashboard card (page-dashboard/PreSeasonEntriesCard).
import { IntlShape } from "react-intl";
import messages from "../page-team-pre-season/PageTeamPreSeason.intl";

export const WEEKDAYS: Array<{ value: number; messageKey: keyof typeof messages }> = [
  { value: 1, messageKey: "monday" },
  { value: 2, messageKey: "tuesday" },
  { value: 3, messageKey: "wednesday" },
  { value: 4, messageKey: "thursday" },
  { value: 5, messageKey: "friday" },
  { value: 6, messageKey: "saturday" },
  { value: 7, messageKey: "sunday" },
];

export const getWeekdayLabels = (intl: IntlShape) =>
  WEEKDAYS.reduce((acc: any, day) => {
    acc[day.value] = intl.formatMessage(messages[day.messageKey]);
    return acc;
  }, {});

export const EXERCISE_TYPES = ["RUNNING", "STRENGTH", "GENERIC"] as const;
export type ExerciseType = typeof EXERCISE_TYPES[number];

export const getExerciseTypeLabels = (intl: IntlShape) => ({
  RUNNING: intl.formatMessage(messages.typeRunning),
  STRENGTH: intl.formatMessage(messages.typeStrength),
  GENERIC: intl.formatMessage(messages.typeGeneric),
});

export const SKIP_REASONS = ["INJURY", "ILLNESS", "TRAVEL", "REST", "OTHER"] as const;
export type SkipReason = typeof SKIP_REASONS[number];

export const getSkipReasonLabels = (intl: IntlShape) => ({
  INJURY: intl.formatMessage(messages.reasonInjury),
  ILLNESS: intl.formatMessage(messages.reasonIllness),
  TRAVEL: intl.formatMessage(messages.reasonTravel),
  REST: intl.formatMessage(messages.reasonRest),
  OTHER: intl.formatMessage(messages.reasonOther),
});
